import { observable, action } from "mobx";
import toastService from "src/services/ToastService";

export default class CompareCubeStore {
  constructor(http) {
    this.http = http;
  }

  @observable
  tid;

  @action
  fetchPossibleObjectsForComparison = async (objectType, frameworkId, referenceObjectTid, limit, offset, searchExpr) => {
    return this.http
      .getPossibleObjectsForComparison(objectType, frameworkId, referenceObjectTid, limit, offset, searchExpr)
      .then((results) => {
        return results;
      });
  };
  @action
  getAllObjectVersions = async (objectType, objectCode) => {
    return this.http
      .getAllObjectVersions(objectType, objectCode)
      .then((results) => {
        return results;
      });
  };
  @action
  getDeepChanges = async (baseObject, comparedObjectInfo) => {
    let params = {
      baseObjectTid: baseObject.tid,
      baseObjectType: baseObject.type,
      comparedObjectInfo: comparedObjectInfo,
    };
    const result = await this.http.getDeepChanges(params);

    if (result?.warning) {
      toastService.func_notify(result.warning, "warn")
    }

    return result;
  };
}
